<template>
  <div class="innerBox">
    <Main></Main>
  </div>

</template>
<script>
  import Main from '@/views/Biz/Home/Main';
  let myApp;

  export default{
    components: {
      Main,
    },
    data(){
      return {
      }
    },
    methods: {
      //初始化数据
      initLoad: function () {
        myApp = this;
      },
    },
    mounted(){
      this.initLoad();
    },
    destroyed(){
    },
  }
</script>
<style scoped>
  .innerBox {
    width: 100%;
    height: 100%;
    /*background-color: ;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/Biz/Home/Home.vue